var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowShrink component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowShrink extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.6748 1.32459C22.9676 1.61748 22.9676 2.09236 22.6748 2.38525L16.1512 8.90879H20.5837C20.9979 8.90879 21.3337 9.24457 21.3337 9.65879C21.3337 10.073 20.9979 10.4088 20.5837 10.4088H14.3406C14.2292 10.4088 14.1234 10.3845 14.0284 10.3409C13.9641 10.3115 13.9032 10.2726 13.8477 10.2241C13.8231 10.2026 13.7999 10.1796 13.7783 10.1552C13.6615 10.0229 13.5906 9.84914 13.5906 9.65879V3.41571C13.5906 3.0015 13.9264 2.66571 14.3406 2.66571C14.7548 2.66571 15.0906 3.0015 15.0906 3.41571V7.8481L21.6141 1.32459C21.907 1.0317 22.3819 1.0317 22.6748 1.32459ZM10.1547 13.7788C10.0225 13.6619 9.84871 13.591 9.65836 13.591H3.41528C3.00107 13.591 2.66528 13.9268 2.66528 14.341C2.66528 14.7552 3.00107 15.091 3.41528 15.091H7.84768L1.32416 21.6145C1.03127 21.9074 1.03127 22.3823 1.32416 22.6752C1.61706 22.9681 2.09193 22.9681 2.38482 22.6752L8.90836 16.1516V20.5841C8.90836 20.9983 9.24415 21.3341 9.65836 21.3341C10.0726 21.3341 10.4084 20.9983 10.4084 20.5841V14.341C10.4084 14.2296 10.3841 14.1238 10.3405 14.0288C10.3111 13.9645 10.2722 13.9036 10.2237 13.8481C10.2022 13.8235 10.1792 13.8004 10.1547 13.7788Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowShrink.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowShrink.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowShrink.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-shrink') === undefined) {
    customElements.define('cat-icon-arrow-shrink', BlocksIconArrowShrink);
}
